import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import "./DiaExecucaoHeader.css";
import { formatDiaSemana, formatDiaGrande, formatWeekdayUpper, formatDayMonth } from "../utils/DateUtils";


const DiaExecucaoHeader = ({
  selectedDate,
  isToday,
  onPrev,
  onNext,
  onToday,
  onAbrirPlanejamento,
  onRevisao,
  onVitoria
}) => {

  const weekday = formatWeekdayUpper(selectedDate);
  const dayMonth = formatDayMonth(selectedDate);



  return (
    <div className="diaexec-header">
      <div className="diaexec-toprow">
        <div className="diaexec-navcol">
          <button className="diaexec-navbtn" onClick={onPrev}>
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>
          <button className="diaexec-navbtn" onClick={onNext}>
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </div>

        <div className="diaexec-titlewrap">
          <div className="diaexec-subtitle">{weekday}</div>
          <h1 className="diaexec-title">{dayMonth}</h1>
          {isToday && <span className="diaexec-chip-hoje">Hoje</span>}
          {!isToday && <button className="btn btn-outline-secondary" onClick={onToday}>Ir para hoje</button>}
                  

        </div>
      </div>
    </div>

  );
};

export default DiaExecucaoHeader;
